/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { UserEntity } from "@/models/userEntity";
import { MrfiktivHttpClientProvider as Api } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { IUserRoleUpdateDto } from "@/store/interface/user.role.dto.interface";
import { IUserPermissionUpdateDto } from "../../../store/interface/user.permission.dto.interface";
import {
  MrfiktivCreateUserDtoGen,
  MrfiktivPermissionDtoGen,
  MrfiktivUpdateUserDtoGen as UpdateUserDto
} from "../v1/data-contracts";
class AdminUserService {
  ROUTE = "/user";

  /**
   * The HttpClient containing the Axios Instance
   */
  // client: HttpClient;

  /**
   * The proxy.
   */
  // proxy: User;

  /**
   * @class Initialize SettingService
   */
  constructor() {
    // this.proxy = new User(this.client); // FIXME: Refactor into Proxy
  }

  async get(id: string): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.get(`${this.ROUTE}/${id}`);
    return response.data as UserEntity;
  }

  async resendInvitation(id: string): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.post(`${this.ROUTE}/${id}/resendInvitationMessage`);
    return response.data as UserEntity;
  }

  async getAll(): Promise<UserEntity[]> {
    const api = new Api().instance();
    const response = await api.get(`${this.ROUTE}/all`);
    return response.data as UserEntity[];
  }

  async getByAuthInfo(): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.get(`${this.ROUTE}`);
    return response.data as UserEntity;
  }

  async update(id: string, updateUser: UpdateUserDto): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.patch(`${this.ROUTE}/${id}`, updateUser);
    return response.data as UserEntity;
  }

  async removePermission(updatePermission: IUserPermissionUpdateDto): Promise<UserEntity> {
    const api = new Api().instance();
    const dto = {
      permission: updatePermission.permissions
    };

    const response = await api.patch(`${this.ROUTE}/${updatePermission.id}/permission/remove`, dto);
    return response.data as UserEntity;
  }

  async addPermissions(userId: string, dto: { permission: MrfiktivPermissionDtoGen[] }): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.patch(`${this.ROUTE}/${userId}/permission/add`, dto);
    return response.data as UserEntity;
  }

  async addPermissionsByUser(user: UserEntity): Promise<UserEntity> {
    const api = new Api().instance();
    const dto = {
      permission: user.permission
    };

    const response = await api.patch(`${this.ROUTE}/${user._id}/permission/add`, dto);
    return response.data as UserEntity;
  }

  async updateRole(userRole: IUserRoleUpdateDto): Promise<UserEntity> {
    const api = new Api().instance();
    const dto = {
      roles: userRole.role
    };

    const response = await api.patch(`${this.ROUTE}/${userRole.id}/role`, dto);
    return response.data as UserEntity;
  }

  async invite(createUser: MrfiktivCreateUserDtoGen): Promise<UserEntity> {
    const api = new Api().instance();
    const response = await api.post(`${this.ROUTE}/invite/asAdmin`, createUser);
    return response.data as UserEntity;
  }

  async create(createUser: UserEntity): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.post(`${this.ROUTE}`, createUser);
    return response.data as UserEntity;
  }

  async delete(id: string): Promise<UserEntity> {
    const api = new Api().instance();

    const response = await api.delete(`${this.ROUTE}/${id}/delete`);
    return response.data as UserEntity;
  }
}

export default new AdminUserService();
